import React, {useState} from 'react';
import {
    Box,
    Button,
    HStack,
} from "@chakra-ui/react";
import { SecureIframe } from './components/SecureIframe';


const ReserveSettings: React.FC = () => {
    const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL;
    const [src, setSrc] = useState(`${baseUrl}/shop_manager/shop_reservation_staff`);

    const menu = [
        { label: "予約担当者", url: `${baseUrl}/shop_manager/shop_reservation_staff` },
        { label: "予約メール", url: `${baseUrl}/shop_manager/shop_mail` },
        { label: "予約受付締切日", url: `${baseUrl}/shop_manager/shop_reservation_cut_off_times` },
        { label: "予約タグ", url: `${baseUrl}/shop_manager/tags` },
        { label: "キャンセルポリシー", url: `${baseUrl}/shop_manager/cancellation_policy` },
        { label: "コース", url: `${baseUrl}/shop_manager/course` },
    ];

    return (
        <Box
            transform="scale(0.8)"
            transformOrigin="top left"
            width="125%"   // 1 / 0.8 = 1.25 → 見切れ防止
            height="125%"
        >
            <HStack spacing={4} mb={4} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                {menu.map((item) => (
                    <Button
                        key={item.label}
                        onClick={() => setSrc(item.url)}
                        colorScheme="blue"
                        variant="outline"
                    >
                        {item.label}
                    </Button>
                ))}
            </HStack>
            <SecureIframe src={src} />
        </Box>
    );
};

export default ReserveSettings;